<div class="chat-contact" style="
    background-color: white;
    width: 400px;
    height: 500px;
    overflow-y: auto;
    padding: 15px;
  ">
  <!-- <div class="d-flex justify-content-between"> -->
  <div>
    <span>
      <strong style="font-size: 18px;">{{ "CONTACTINFO.CONTACT_INFO" | translate }}</strong>
    </span>
    <span style="float:right" (click)="gotoAddressbook()"><mat-icon>close</mat-icon></span>
  </div>
  <hr />
  <!-- <div style="text-align: right">
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      aria-label="Example icon-button with a menu"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="gotoAddressbook()">
        <span>{{ "CONTACTINFO.ADDRESS_BOOK" | translate }}</span>
      </button>
      <button mat-menu-item (click)="gotoNewMessage()">
        <span>{{ "CONTACTINFO.NEW_MSG" | translate }}</span>
      </button>
      <button mat-menu-item (click)="gotoConversation()">
        <span>{{ "CONTACTINFO.MESSAGES" | translate }}</span>
      </button>
      <button mat-menu-item (click)="close()">
        <span>{{ "CONTACTINFO.CLOSE" | translate }}</span>
      </button>
    </mat-menu>
  </div> -->
  <!-- </div> -->
  <div class="container contact-info">
    <div>
      <!-- <div class="row"> -->
      <span>{{ user.user.name }}</span>
      <br />
      <span>{{ getRoleName(user.Role) }}, {{ user.user.agencycode.toUpperCase() }}</span>
      <br />
      <span>{{ user.user.Branch ? "Branch: " + user.user.Branch : "" }}</span>
      <!-- <span>{{ user.user.Branch ? "Branch: " + user.user.Branch : "(Branch Missing)" }}</span> -->
    </div>

    <hr />

    <div class="col">
      <!-- <h2>{{ "CONTACTINFO.CONTACT_DETAILS" | translate }}</h2> -->
      <ul class="list-unstyled">
        <!-- <li class="mt-2">
          <address class="d-flex align-items-center">
            <mat-icon>pin_drop</mat-icon>
            {{ user.agencycode.toUpperCase() }}
          </address>
        </li> -->
        <li class="mt-2">
          {{ "CONTACTINFO.MOBILE_PHONE" | translate }}
          <a *ngIf="isMobile" [href]="getPhone(user.user)" onclick="return confirm('Call This User?')">
            {{ user.user.PhoneNumber }}
            <i class="fa fa-phone"></i>
          </a>
          <span *ngIf="!isMobile" style="font-size: 14px;">{{ user.user.PhoneNumber }}</span>
          <span *ngIf="isMobile">
            <mat-form-field style="width: 300px;">
              <input matInput type="text" class="form-control" [(ngModel)]="callNote" #inputSearch
                [placeholder]="'CONTACTINFO.CALL_NOTE' | translate" />
              <button *ngIf="callNote" matSuffix mat-icon-button aria-label="Clear" (click)="clearCallNote()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <i style="margin-left: 10px;" class="fa fa-sticky-note fa-xl" (click)="logCallNote()"></i>
          </span>
        </li>
        <li class="mt-2 align-items-center">
          {{ "CONTACTINFO.WORK_PHONE" | translate }}
          <a *ngIf="isMobile" [href]="getPhone(user.user)">{{ user.user.WorkPhone }}</a>
          <span *ngIf="!isMobile" style="font-size: 14px;">{{ user.user.WorkPhone }}</span>
        </li>
        <li class="mt-2">
          {{ "CONTACTINFO.FAX" | translate }}
          <a *ngIf="isMobile" [href]="getPhone(user.user)">{{ user.user.FaxNumber }}</a>
          <span *ngIf="!isMobile" style="font-size: 14px;">{{ user.user.FaxNumber }}</span>
        </li>
        <li class="mt-2">
          {{ "CONTACTINFO.EMAIL" | translate }}
          <a *ngIf="isMobile" [href]="getEmail(user.user)">{{ user.user.email }}</a>
          <span *ngIf="!isMobile" style="font-size: 14px;">{{ user.user.email }}</span>
        </li>
        <li class="mt-2">
          <div>
            {{ "CONTACTINFO.TAGS" | translate }}
            <span *ngIf="editTags">
              <button class="btn btn-link" (click)="tagEdit()">close edit</button>
            </span>
            <div class="chip-container" *ngIf="editTags">
              <div *ngFor="let tag of tagList" class="chip">
                {{ tag }}
                <mat-icon class="remove-icon" [class.read-only]="isViewPage"
                  (click)="!isViewPage ? removeTag(tag) : null">
                  cancel
                </mat-icon>
              </div>
            </div>
            <span *ngIf="!editTags" style="font-size: 14px; margin-left: 5px;">
              {{ this.user.user.tags ? this.user.user.tags.replaceAll(";",", ") : "" }}
            </span>
            <span *ngIf="!editTags && !isCaregiver">
              <button class="btn btn-link" (click)="tagEdit()">edit</button>
            </span>
          </div>
        </li>
        <li *ngIf="editTags">
          <mat-form-field style="width: 290px;">
            <input matInput type="text" class="form-control" [(ngModel)]="addTag" #inputTag
              [placeholder]="'CONTACTINFO.ADD_TAG' | translate" />
            <button *ngIf="addTag" matSuffix mat-icon-button aria-label="Clear" (click)="clearTag()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <i style="margin-left: 10px;" class="fa fa-plus-square fa-xl" (click)="addNewTag()"></i>
        </li>
      </ul>
    </div>
    <!-- </div> -->

    <div class="text-center mt-5">
      <button class="sc-btn gold-gradient" (click)="gotoChat()">
        {{ "CONTACTINFO.SEND_MESSAGE" | translate }}
      </button>
    </div>
  </div>
</div>